import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { LoginService } from 'src/app/shared/services/login/login.service';
// import { SessionMgmtService } from 'src/app/shared/services/session-mgmt/session-mgmt.service';
import { AccountsService } from 'src/app/shared/services/accounts/accounts.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { ManagersService } from 'src/app/shared/services/managers/managers.service';
import { GlobalFilterService } from 'src/app/shared/services/filters/global-filter.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as _ from 'lodash';
import { forkJoin, map } from 'rxjs';
import { debounceTime, retry } from 'rxjs/operators';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { SidebarService } from 'src/app/shared/services/sidebar/sidebar.service';
import { URLS_CONST } from 'src/app/shared/constants/url-constants';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { UserActivitiesService } from 'src/app/shared/services/user-activities/user-activities.service';
import { NgIf } from '@angular/common';
import { LitmusHeaderComponent } from '../../../shared/components/header/litmus-header.component';
import { SideBarComponent } from '../../../shared/components/side-bar/side-bar.component';
import { LtmsDownloadWidgetComponent } from '../../../shared/components/ltms-download-widget/ltms-download-widget.component';
import { LtmsCustomFieldRenderComponent } from '../../../shared/components/ltms-custom-field-render/ltms-custom-field-render.component';
import { LtmsGlobalFilterSideBarComponent } from '../../../shared/filters/ltms-global-filter-side-bar/ltms-global-filter-side-bar.component';
import { LtmsFilterDrawComponent } from '../../../shared/filters/ltms-global-filter-draw/ltms-global-filter-draw.component';
import { LitmusFooterComponent } from '../../../shared/components/footer/litmus-footer.component';
import { LtmsLoaderComponent } from '../../../shared/components/ltms-loader/ltms-loader.component';
import { SideBarV2Component } from "src/app/shared/components/side-bar-v2/side-bar-v2.component";
import { AdminService } from 'src/app/shared/services/admin-panel/admin.service';
import { SideBarConfigs } from 'src/app/shared/components/side-bar-v2/config';

@Component({
    selector: 'app-project-default-routing',
    templateUrl: './project-default-routing.component.html',
    styleUrls: ['./project-default-routing.component.scss'],
    host: {
        class: 'router-outlate-container'
    },
    imports: [NgIf, LitmusHeaderComponent, LtmsDownloadWidgetComponent, LtmsCustomFieldRenderComponent, LtmsGlobalFilterSideBarComponent, LtmsFilterDrawComponent, RouterOutlet, LitmusFooterComponent, LtmsLoaderComponent, SideBarV2Component]
})
export class ProjectDefaultRoutingComponent {
  destroyRef = inject(DestroyRef);
  projectId: string = '';
  accountId: string = '';
  accountDetails: any = {};
  brandDetails: any = {};
  moduleConfigs: any = {};
  isInitalDataLoaded: boolean = false;
  showModel = false;
  activeTab: string = ''
  adminRules: any = [];
  constructor(
    private _route: ActivatedRoute,
    // private _session: SessionMgmtService,
    private _accountService: AccountsService,
    private _helpers: HelpersService,
    private _loginService: LoginService,
    private _managerSevice: ManagersService,
    private _filterService: GlobalFilterService,
    private router: Router,
    private headerService: HeaderService,
    private sidebarService: SidebarService,
    private appStateService: AppStateService,
    private userActivitiesService:UserActivitiesService,
    private adminService: AdminService
  ) {
    this.isInitalDataLoaded = false;
    this._helpers.setPendingState(true, true);
    this.initAppData()
    this._route.queryParams.subscribe(() => {
      const container = document.getElementById('projectRouterOutlet');
      if(container){
        container.scrollTop = 0;
      }
    });

  }

  initAppData() {
    this._route.queryParams.pipe(
      debounceTime(300),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(params => {
      // console.log("1111111111111111", params)
      this.isInitalDataLoaded = false;
      let url = this.router.url;
      let routesDetails = this._helpers.prepareRouteData(url);
      // check the required parameter from query params
      const account_id = _.get(params, 'account_id', null);
      const project_id = _.get(params, 'project_id', null);
      this.activeTab = _.get(params, 'active_tab', null);
      // If user already loggedIn with this account and project.
      const currentLoggedInBrandId = _.get(Helpers, 'managerDetails.loggedInManager.brand_id', null);
      const currentLoggedInAccountId = _.get(Helpers, 'managerDetails.loggedInManager.account_id', null);

      // Check if account id and project id is available on URL.
      if (account_id && account_id != null && project_id && project_id != null) {
        // this is used  to reset universal filter while swithching between account and project or filter is applied.
        this._helpers.resetUniversalFilter(false);
        // console.log("2222222222222222222222");
        // check if current or previous account/project id is same or not.

        if (this.accountId != account_id && this.projectId != project_id) {
          // console.log("33333333333333333")
          // if user is logging first time or change the parameters value
          this.accountId = account_id;
          this.projectId = project_id;
          this._helpers.resetAppState('project');
          // check if loggedIn brand id and current selected project id is same or not
          // if changed - means, user singed with other project/account and try to load new project.
          if (currentLoggedInBrandId != params['project_id']) {
            // #todo - load the complete data
          } else {
            // #todo - if account and project, both changed or first time - call API to get details
          }
          this.getAccountAndProjectDetails(routesDetails);
        } else {
          // console.log("4444444444444444")
          // checking - if user used multiple tab inbetween using same tab
          // console.log(currentLoggedInBrandId, '...1111.......', project_id)
          if (currentLoggedInBrandId && currentLoggedInBrandId != project_id) {
            // console.log("555555555555555555555")
            this.accountId = params['account_id'];
            this.projectId = params['project_id'];
            this._helpers.resetAppState('project')
            if (this.showModel == false) { 
              this.openModal();
            }
          } else {
            // console.log("6666666666666666666666");
            // console.log("Do nothing...");
            this.isInitalDataLoaded = true;
          }
        }
      } else {
        this.isInitalDataLoaded = true;
        // URLModified
        this.router.navigate(["message"], { queryParams: { status: '405' } });
      }

    });

    this.userActivitiesService.isCurrentLoggedInBrandIdChanged.subscribe((isCurrentLoggedInBrandIdChanged) => {
      if(isCurrentLoggedInBrandIdChanged == true && this.showModel == false){
        this.showModel = true;
      }else if(isCurrentLoggedInBrandIdChanged == false && this.showModel == true){
        this.showModel = false;
      }
    })
  }

  getAccountAndProjectDetails(routesDetails: any) {
    // console.log("Getting Account and project details.......", this.accountId, this.projectId)
    const apicalls = {
      accountDetails: this._accountService.getAccountDetail(this.accountId),
      brandDetails: this._accountService.getBrandDetail(this.projectId),
      moduleConfig: this._accountService.getModulConfigs({ brand_id: this.projectId }),
      adminRules: this.adminService.getRules(this.projectId)
    }
    forkJoin(apicalls).pipe(map((response) => {
      return Object(response)
    })).pipe(
      retry(3),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((response: any) => {
      const details: any = {}
      if (_.get(response, 'accountDetails.code') == 0 && !_.isEmpty(response, 'accountDetails.data.account')) {
        this.accountDetails = _.get(response, 'accountDetails.data.account')
      }
      if (_.get(response, 'brandDetails.code') == 0 && !_.isEmpty(response, 'brandDetails.data.brand')) {
        this.brandDetails = _.get(response, 'brandDetails.data.brand')
      }
      if (_.get(response, 'moduleConfig.data.code') == 0 && !_.isEmpty(response, 'moduleConfig.data.module_configuration_v2')) {
        this.moduleConfigs = _.get(response, 'moduleConfig.data.module_configuration_v2');
      }
      if (_.get(response, 'adminRules.code') == 0 && !_.isEmpty(response, 'adminRules.data.rules')) {
        this.adminRules = _.get(response, 'adminRules.data.rules')
      }
      // console.log("Account and project details..", this.accountDetails, this.brandDetails);
      if (!_.isEmpty(this.accountDetails) && !_.isEmpty(this.brandDetails) && this.brandDetails.is_single_touchpoint_setup) {
        // if every thing is okaya....
        if (this.accountDetails['_id'] == this.brandDetails['account_id']) {
          this.loadInitialData(this.accountDetails, this.brandDetails, this.moduleConfigs, routesDetails, this.adminRules)
        } else {
          this.isInitalDataLoaded = true;
          // URL_MODIFIED_WITH_MAJOR_ISSUE
          this.router.navigate(["message"], { queryParams: { status: '405' } });
        }
      } else {
        this.isInitalDataLoaded = true;
        // UnsupportedHierarchyProject
        this.router.navigate(["message"], { queryParams: { status: '406' } });
      }

    })
  }

  setBrandAndAccountDetailsForCurrentManager() {
    // console.log("Setting up this project as current loggedin project .......");
    // If user already loggedIn with this account and project.
    const currentLoggedInBrandId = _.get(Helpers, 'managerDetails.loggedInManager.brand_id', null);
    const currentLoggedInAccountId = _.get(Helpers, 'managerDetails.loggedInManager.account_id', null);
    if (currentLoggedInBrandId && currentLoggedInBrandId != null && currentLoggedInAccountId && currentLoggedInAccountId != null) {
      if (currentLoggedInAccountId == this.accountId && currentLoggedInBrandId == this.projectId) {
        this.appStateService.collectDefaultValuesForAppState(this.accountDetails, {}, this.brandDetails,  Helpers.managerDetails, 'project',(success)=>{
          this.isInitalDataLoaded = true;
        });
      } else {
        // console.log("Setting up this project as current loggedin project .......doing...else");
        this._managerSevice.setCurrentLoggedInManager(this.accountId, this.projectId).pipe(
          takeUntilDestroyed(this.destroyRef)
        ).subscribe((reponse: any) => {
          this.getCurrentManagerDetails();
          // this.isInitalDataLoaded = true;
        });
      }
    } else {
      // console.log("Setting up this project as current loggedin project .......doing...");
      this._managerSevice.setCurrentLoggedInManager(this.accountId, this.projectId).pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((reponse: any) => {
        this.getCurrentManagerDetails();
        // this.isInitalDataLoaded = true;
      });
    }

  }

  getCurrentManagerDetails() {
    // console.log("Getting current loggedIn manager details....")
    // this.isInitalDataLoaded = true;
    this._loginService.getManagerDetails().pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((response: any) => {
      if (_.get(response, 'code') == 0 && !_.isEmpty(response, 'data')) {
        response.data['last_synced_details'] = new Date().getTime();
        this._helpers.helpers['managerDetails'] = _.get(response, 'data');
        window['Helpers'] = this._helpers.consoleData();
        if (this.isContinueToThisProject) {
          // window.location.reload();
        }
        this.appStateService.collectDefaultValuesForAppState(this.accountDetails, {}, this.brandDetails,  Helpers.managerDetails, 'project',(success)=>{
          this.isInitalDataLoaded = true;
        });
      }else{
        console.log("Error while calling me API Error:", response)
      }
    });

  }

  loadInitialData(accountDetails: any, brandDetails: any, moduleConfigs: any, routesDetails: any, adminRules: any) {
   // if (this._accountService.isLw3PermittedAccount(accountDetails)) {
      const brandIdList = _.get(accountDetails, 'brands', []);
      const managerAccess = _.get(Helpers, 'managerDetails.manager.manager_access', []);

      if (brandIdList && _.includes(brandIdList, brandDetails._id)) {
        const accessArr = _.filter(managerAccess, { 'account_id': accountDetails._id, has_dashboard_access: true, is_verified: true });

        if (!_.isEmpty(accessArr)) {
          const brandAcccess = _.find(accessArr, { brand_id: brandDetails._id });
          const AccountAcccess = _.find(accessArr, { 'manager_type': 3 });
          
          this._helpers.helpers['adminRules'] = adminRules;
          const managerEmail = _.get(Helpers, 'managerDetails.manager.email_address', '');
          const adminRulesDic = this.adminService.createPermissionDictionary(adminRules, managerEmail, brandDetails, 'project');
          this._helpers.setPermissionContext('project', adminRules, adminRulesDic);
          let queryParamsObject = {};
          this._helpers.helpers['isAccountManager'] = true;

          if (!_.isEmpty(brandAcccess)) {
            queryParamsObject = brandAcccess;
            this._helpers.helpers['isAccountManager'] = false;
            this._helpers.helpers['hasAccessKeys'] = (_.has(brandAcccess, 'access_key') && !_.isEmpty(brandAcccess.access_key)) ? true : false
          } else if (!_.isEmpty(AccountAcccess)) {
            queryParamsObject = {
              "manager_type": 3,
              "account_id": accountDetails._id,
              "brand_id": brandDetails._id
            };
          } else {
            // console.log("No access found for this project...")
            // UnauthrizedAccess
            this.isInitalDataLoaded = true;
            this.router.navigate(["message"], { queryParams: { status: '401' } });
          }

          if (!_.isEmpty(queryParamsObject)) {
            this._filterService.prepareAndSetFilterData(brandDetails, (filters: any) => {
              // console.log("filters",filters)
            })
            // console.log("moduleConfigs", moduleConfigs);
            // console.log(" brandDetails.module_configuration_v2", brandDetails.module_configuration_v2)
            const moduleConfig = (!_.isEmpty(moduleConfigs)) ? moduleConfigs : brandDetails.module_configuration_v2;

            const module_configuration_v2 = this._helpers.getFlatenModuleConfig(moduleConfig, false)

            const mainMenu = (_.hasIn(module_configuration_v2, 'project.mainMenu')) ? module_configuration_v2.project.mainMenu : {};
            let menuItems = this._helpers.getActiveSideMenu(false,accountDetails?._id||brandDetails?.account_id, mainMenu)
            const eligiblepath = (menuItems && menuItems.length) ? _.map(menuItems, (item: any) => item.path) : [];

            this._helpers.helpers['moduleConfigs'] = module_configuration_v2;
            this._helpers.helpers['projectModuleConfigs'] = module_configuration_v2;
            // this._helpers.helpers['isAccount'] = false;
            let labelConfig = {}; // labelConfig data comes from brand/account
            if (brandDetails && brandDetails.label_configs) {
              labelConfig = brandDetails.label_configs
            }
            this._helpers.setLabelConfigs(labelConfig);
            window['Helpers'] = this._helpers.consoleData();
            this.appStateService.storeRecentVisitProject(brandDetails, _.get(Helpers, 'managerDetails',{}));
            this._helpers.setInitialData(accountDetails, queryParamsObject, managerAccess, brandDetails)
            // console.log("menuItems", menuItems)
            if (routesDetails.routeName != 'settings' && !(eligiblepath && eligiblepath.indexOf(routesDetails.routeName) >= 0)) {
              if (menuItems && menuItems.length) {
                const redirectUrl = 'account/project/' + menuItems[0].path
                this.router.navigate([redirectUrl], {
                  queryParams: {
                    account_id: accountDetails._id,
                    project_id: brandDetails._id
                  }
                });
              } else {
                // console.log("No tab is  visible")
                this.isInitalDataLoaded = true;
                // this.router.navigate(["UnauthrizedAccess"]);
                this.router.navigate(["message"], { queryParams: { status: '404' } });
              }
            }else if(routesDetails.routeName == 'settings' && routesDetails.subRouteName !== '' && routesDetails.subRouteName !== null && routesDetails.subRouteName !== 'admin'){
              const isSelectedMenuActive = this._helpers.isSettingsMenuVisible(routesDetails.subRouteName, this._helpers.helpers['adminRulesDic']);
              const settingsMenu = this._helpers.getSettingsMenuItems();
              if(!isSelectedMenuActive && settingsMenu && !_.isEmpty(settingsMenu) && settingsMenu.visible && settingsMenu.submenu && !_.isEmpty(settingsMenu.submenu)){
                const redirectUrl = 'account/project/' + settingsMenu.submenu[0].path
                this.router.navigate([redirectUrl], {
                  queryParams: {
                    account_id: accountDetails._id,
                    project_id: brandDetails._id
                  }
                });
              }else if(!isSelectedMenuActive){
                this.router.navigate(["message"], { queryParams: { status: '404' } });
              }
            }

            this.isInitalDataLoaded = true;

            this.setBrandAndAccountDetailsForCurrentManager();

          } else {
            // console.log("No Found any access")
            this.isInitalDataLoaded = true;
            // this.router.navigate(["UnauthrizedAccess"]);
            this.router.navigate(["message"], { queryParams: { status: '402' } });
          }
        } else {
          console.log("No access on brand/account... ")
          this.isInitalDataLoaded = true;
          // this.router.navigate(["UnauthrizedAccess"]);
          this.router.navigate(["message"], { queryParams: { status: '401' } });
        }
      } else {
        // console.log("Brand ID not found")
        this.isInitalDataLoaded = true;
        // this.router.navigate(["UnauthrizedAccess"]);
        this.router.navigate(["message"], { queryParams: { status: '405' } });
      }
    // } else {
    //   this.isInitalDataLoaded = true;
    //   // this.router.navigate(["AccountNotAllowedOnLW3"]);
    //   this.router.navigate(["message"], { queryParams: { status: '402' } });
    // }
  }

  isContinueToThisProject = false;
  // Set the active project from loggedInManager details.
  continueToThisProject() {
    this.isContinueToThisProject = true;
    // this.getAccountAndProjectDetails();
    this.setBrandAndAccountDetailsForCurrentManager()
    this.showModel = false;
  }


  loadTheActiveSessionProject() {
    this.isInitalDataLoaded = false;
    const currentLoggedInBrandId = _.get(Helpers, 'managerDetails.loggedInManager.brand_id', null);
    const currentLoggedInAccountID = _.get(Helpers, 'managerDetails.loggedInManager.account_id', null);
    // console.log(currentLoggedInBrandId, currentLoggedInAccountID)
    this.accountId = '';
    this.projectId = '';
    this._helpers.resetAppState('project');
    this.appStateService.initialized.set(false)
    this.appStateService.resetAppstate('project')
    this.showModel = false;
    this.router.navigate([], {
      relativeTo: this._route,
      queryParams: { account_id: currentLoggedInAccountID, project_id: currentLoggedInBrandId },
      queryParamsHandling: 'merge'
    });
  }

  // This function will enable the flag for open Switch project pop up
  openModal(): void {
    this.showModel = true;
  }

  // This function will enable the flag for close Switch project pop up
  closeModal(): void {
    this.showModel = false;
    this.isInitalDataLoaded = true;
  }

}


// Need below details/API to collect the data
// 1. Get Account Details = Done
// 2. Brand details = Done
// 3. Current loggedin manager details and set current loggedin manager- = Done
